import type { FaireProductEntity } from "../../entity_types/product";

export const p_a9rt24w0gn: FaireProductEntity = {
  token: "p_a9rt24w0gn",
  type: "product",
  name: "Pacific Ocean \u00b7 California Candle \u00b7 Amber Jar 8oz",
  brandName: "Candlefy",
  imageUrl:
    "https://cdn.faire.com/fastly/a85c822f50148f5998ecb74b1873eb24fd2a114656101ef0aa23cbcfeb59d1a0.jpeg",
  priceDollars: 10.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/eb41382ff91746197096e7f5c1c13600682ba6e226e5ef492c42c8c2d2399be0.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
